import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { RoleInfoComponent } from './components/roles/role-info/role-info.component';
import { LoginComponent } from './components/auth/login/login.component';
import { CargoOwnerRegistrationComponent } from './components/auth/registration/cargo-owner-registration/cargo-owner-registration';
import { FreightForwarderRegistrationComponent } from './components/auth/registration/freight-forwarder-registration/freight-forwarder-registration';
import { PublicRegistrationComponent } from './components/auth/registration/public-registration/public-registration';
import { ProfileComponent } from './components/profile/profile/profile';
import { CompanyMembersComponent } from './components/company/company-members/company-members';
import { CargoOwnerDashboardComponent } from './components/cargo-owner/cargo-owner-dashboard/cargo-owner-dashboard';
import { CreateRequestComponent } from './components/cargo-owner/create-request/create-request';
import { ViewRequestComponent } from './components/cargo-owner/view-request/view-request';
import { ViewBidComponent } from './components/cargo-owner/view-bid/view-bid';
import { UsersListComponent } from './components/admin/users-list/users-list';
import { VisitorStatsComponent } from './components/admin/visitor-stats/visitor-stats.component';
import { UserViewComponent } from './components/admin/user-view/user-view';
import { UserEditComponent } from './components/admin/user-edit/user-edit';
import { FreightForwarderRequestsListComponent } from './components/freight-forwarder/freight-forwarder-requests-list/freight-forwarder-requests-list';
import { FfOverviewComponent } from './components/freight-forwarder/ff-overview/ff-overview.component';
import { FfCounterpartiesComponent } from './components/freight-forwarder/ff-counterparties/ff-counterparties.component';
import { CoOverviewComponent } from './components/cargo-owner/co-overview/co-overview.component';
import { CoCertificationComponent } from './components/cargo-owner/co-certification/co-certification.component';
import { CoSupplyComponent } from './components/cargo-owner/co-supply/co-supply.component';
import { FreightForwarderDashboardComponent } from './components/freight-forwarder/freight-forwarder-dashboard/freight-forwarder-dashboard';
import { CreateBidComponent } from './components/freight-forwarder/create-bid/create-bid';
import { FreightForwarderViewRequestComponent } from './components/freight-forwarder/view-request/view-request';
import { ViewDealComponent } from './components/shared/view-deal/view-deal';
import { ViewDealReportComponent } from './components/shared/view-deal-report/view-deal-report';
import { CustomsBrokerDashboardComponent } from './components/customs-broker/customs-broker-dashboard/customs-broker-dashboard';
import { CustomsBrokerViewRequestComponent } from './components/customs-broker/view-request/view-request';
import { PublicDashboardComponent } from './components/public/public-dashboard/public-dashboard';
import { CreateCalculationComponent } from './components/public/create-calculation/create-calculation';
import { CALC_CABINET_ROLES } from './components/shared/customs-calculations/calculation-sections';
import { ViewCalculationComponent } from './components/public/view-calculation/view-calculation';
import { OrderSupportComponent } from './components/public/order-support/order-support';
import { ProcessCalculationComponent } from './components/public/process-calculation/process-calculation';
import { SupplierInviteComponent } from './components/auth/registration/supplier-invite/supplier-invite';
import { SupplierDashboardComponent } from './components/supplier/supplier-dashboard/supplier-dashboard';
import { LegalDocumentComponent } from './components/legal/legal-document/legal-document.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { TnvedComponent } from './components/tnved/tnved.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    title: 'pageTitle.home'
  },
  {
    path: 'login',
    component: LoginComponent,
    title: 'pageTitle.login'
  },
  {
    path: 'user-agreement',
    component: LegalDocumentComponent,
    data: { doc: 'user-agreement' },
    title: 'pageTitle.userAgreement'
  },
  {
    path: 'privacy-policy',
    component: LegalDocumentComponent,
    data: { doc: 'privacy-policy' },
    title: 'pageTitle.privacy'
  },
  {
    path: 'personal-data-consent',
    component: LegalDocumentComponent,
    data: { doc: 'personal-data-consent' },
    title: 'pageTitle.personalDataConsent'
  },
  {
    path: 'contacts',
    component: ContactsComponent,
    title: 'pageTitle.contacts'
  },
  {
    path: 'tnved',
    component: TnvedComponent,
    title: 'pageTitle.tnved'
  },
  {
    path: 'profile',
    component: ProfileComponent,
    title: 'pageTitle.profile'
  },
  {
    path: 'info/cargo-owner',
    component: RoleInfoComponent,
    data: { role: 'cargoOwner' },
    title: 'pageTitle.roleCargoOwner'
  },
  {
    path: 'info/freight-forwarder',
    component: RoleInfoComponent,
    data: { role: 'freightForwarder' },
    title: 'pageTitle.roleForwarder'
  },
  {
    path: 'info/customs-broker',
    component: RoleInfoComponent,
    data: { role: 'customsBroker' },
    title: 'pageTitle.roleBroker'
  },
  {
    path: 'info/supplier',
    component: RoleInfoComponent,
    data: { role: 'supplier' },
    title: 'pageTitle.roleSupplier'
  },
  {
    path: 'registration/cargo-owner',
    component: CargoOwnerRegistrationComponent,
    title: 'pageTitle.registration'
  },
  {
    path: 'registration/freight-forwarder',
    component: FreightForwarderRegistrationComponent,
    title: 'pageTitle.registration'
  },
  {
    path: 'registration/public',
    component: PublicRegistrationComponent,
    title: 'pageTitle.registration'
  },
  {
    path: 'registration/supplier',
    component: SupplierInviteComponent,
    title: 'pageTitle.registration'
  },
  {
    path: 'invite/supplier/:token',
    component: SupplierInviteComponent,
    title: 'pageTitle.registration'
  },
  {
    path: 'supplier/dashboard',
    component: SupplierDashboardComponent,
    title: 'pageTitle.dashboard'
  },
  // Cargo Owner Dashboard с вкладками
  {
    path: 'cargo-owner/dashboard',
    redirectTo: 'cargo-owner/overview',
    pathMatch: 'full'
  },
  {
    path: 'cargo-owner/overview',
    component: CoOverviewComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.dashboard'
  },
  {
    path: 'company/members',
    component: CompanyMembersComponent,
    data: { layout: 'platform' },
    title: 'company.members.title'
  },
  {
    path: 'cargo-owner/counterparties',
    component: FfCounterpartiesComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.dashboard'
  },
  {
    path: 'cargo-owner/certification',
    component: CoCertificationComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.dashboard'
  },
  // Поставка: вкладки «Предварительный расчёт → … → Сводка по поставке»
  // Поставка по сделке без расчёта — раньше адресов поставки по расчёту (иначе «deal» примется за id)
  { path: 'cargo-owner/supplies/deal/:dealId', redirectTo: 'cargo-owner/supplies/deal/:dealId/transport', pathMatch: 'full' },
  {
    path: 'cargo-owner/supplies/deal/:dealId/:tab',
    component: CoSupplyComponent,
    data: { layout: 'platform', byDeal: true },
    title: 'pageTitle.supply'
  },
  { path: 'cargo-owner/supplies/:id', redirectTo: 'cargo-owner/supplies/:id/calculation', pathMatch: 'full' },
  {
    path: 'cargo-owner/supplies/:id/:tab',
    component: CoSupplyComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.supply'
  },
  {
    path: 'cargo-owner/dashboard/:tab',
    component: CargoOwnerDashboardComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.dashboard'
  },
  {
    path: 'cargo-owner/create-request',
    component: CreateRequestComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.request'
  },
  {
    path: 'cargo-owner/edit-request/:id',
    component: CreateRequestComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.request'
  },
  {
    path: 'cargo-owner/request/:id',
    component: ViewRequestComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.request'
  },
  {
    path: 'cargo-owner/bid/:bidId',
    component: ViewBidComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.bid'
  },
  // Freight Forwarder Dashboard с вкладками
  {
    path: 'freight-forwarder/dashboard',
    redirectTo: 'freight-forwarder/overview',
    pathMatch: 'full'
  },
  {
    path: 'freight-forwarder/overview',
    component: FfOverviewComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.dashboard'
  },
  {
    path: 'freight-forwarder/counterparties',
    component: FfCounterpartiesComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.dashboard'
  },
  {
    path: 'freight-forwarder/dashboard/:tab',
    component: FreightForwarderDashboardComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.dashboard'
  },
  {
    path: 'freight-forwarder/requests',
    component: FreightForwarderRequestsListComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.requests'
  },
  {
    path: 'freight-forwarder/create-bid/:cargoRequestId',
    component: CreateBidComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.bid'
  },
  {
    path: 'freight-forwarder/edit-bid/:id',
    component: CreateBidComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.bid'
  },
  {
    path: 'freight-forwarder/request/:id',
    component: FreightForwarderViewRequestComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.request'
  },
  {
    path: 'cargo-owner/deal/:id',
    component: ViewDealComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.deal'
  },
  {
    path: 'cargo-owner/deal/:id/report',
    component: ViewDealReportComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.dealReport'
  },
  {
    path: 'freight-forwarder/deal/:id',
    component: ViewDealComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.deal'
  },
  {
    path: 'freight-forwarder/deal/:id/report',
    component: ViewDealReportComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.dealReport'
  },
  // Customs Broker Dashboard с вкладками
  {
    path: 'customs-broker/dashboard',
    redirectTo: 'customs-broker/dashboard/supplies',
    pathMatch: 'full'
  },
  {
    path: 'customs-broker/dashboard/settings',
    component: CustomsBrokerDashboardComponent,
    title: 'pageTitle.dashboard'
  },
  {
    path: 'customs-broker/dashboard/settings/:section',
    component: CustomsBrokerDashboardComponent,
    title: 'pageTitle.dashboard'
  },
  {
    path: 'customs-broker/dashboard/:tab',
    component: CustomsBrokerDashboardComponent,
    title: 'pageTitle.dashboard'
  },
  {
    path: 'customs-broker/request/:id',
    component: CustomsBrokerViewRequestComponent,
    title: 'pageTitle.request'
  },
  {
    path: 'customs-broker/bid/:bidId',
    component: ViewBidComponent,
    title: 'pageTitle.bid'
  },
  {
    path: 'customs-broker/deal/:id',
    component: ViewDealComponent,
    title: 'pageTitle.deal'
  },
  {
    path: 'customs-broker/deal/:id/report',
    component: ViewDealReportComponent,
    title: 'pageTitle.dealReport'
  },
  {
    path: 'customs-broker/document-types',
    redirectTo: 'customs-broker/dashboard/settings/document-types',
    pathMatch: 'full'
  },
  {
    path: 'admin/users',
    component: UsersListComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.users'
  },
  // Расчёты из админки убраны — старый адрес ведёт к пользователям
  { path: 'admin/calculations', redirectTo: 'admin/users', pathMatch: 'full' },
  {
    path: 'admin/stats',
    component: VisitorStatsComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.adminStats'
  },
  {
    path: 'admin/users/create',
    component: UserEditComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.users'
  },
  {
    path: 'admin/users/:id',
    component: UserViewComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.users'
  },
  {
    path: 'admin/users/:id/edit',
    component: UserEditComponent,
    data: { layout: 'platform' },
    title: 'pageTitle.users'
  },
  {
    path: 'public/dashboard',
    component: PublicDashboardComponent,
    data: { layout: 'platform', layoutRoles: ['ROLE_PUBLIC'] },
    title: 'pageTitle.dashboard'
  },
  // Общие маршруты для расчетов (для всех авторизованных пользователей)
  {
    path: 'calculations/new',
    component: CreateCalculationComponent,
    title: 'pageTitle.newCalculation'
  },
  // Расчёт: у клиентов — кабинет с разделами в боковом меню (/calculations/:id/<раздел>),
  // у брокера и поставщика — прежняя страница целиком (layoutRoles ограничивает каркас кабинета)
  {
    path: 'calculations/:id',
    component: ViewCalculationComponent,
    data: { layout: 'platform', layoutRoles: CALC_CABINET_ROLES },
    title: 'pageTitle.calculation'
  },
  // Оформление поставки: грузовладельца отсюда переводим на страницу поставки (/cargo-owner/supplies/:id/…),
  // новый пользователь видит «Перевозку» в кабинете расчёта, брокер — прежнюю страницу с вкладками (layoutRoles).
  {
    path: 'calculations/:id/process',
    component: ProcessCalculationComponent,
    data: { layout: 'platform', layoutRoles: CALC_CABINET_ROLES },
    title: 'pageTitle.calculation'
  },
  {
    path: 'calculations/:id/supplier',
    component: ProcessCalculationComponent,
    data: { layout: 'platform', layoutRoles: CALC_CABINET_ROLES, processSection: 'supply' },
    title: 'pageTitle.calculation'
  },
  {
    path: 'calculations/:id/transport',
    component: ProcessCalculationComponent,
    data: { layout: 'platform', layoutRoles: CALC_CABINET_ROLES, processSection: 'transportation' },
    title: 'pageTitle.calculation'
  },
  // Заявка на платное сопровождение Bilload — из «Стоимости поставки»
  {
    path: 'calculations/:id/support',
    component: OrderSupportComponent,
    data: { layout: 'platform', layoutRoles: CALC_CABINET_ROLES },
    title: 'pageTitle.calculation'
  },
  {
    path: 'calculations/:id/:section',
    component: ViewCalculationComponent,
    data: { layout: 'platform', layoutRoles: CALC_CABINET_ROLES },
    title: 'pageTitle.calculation'
  },
  // Старые маршруты для обратной совместимости (редиректы)
  {
    path: 'public/calculations/new',
    redirectTo: 'calculations/new',
    pathMatch: 'full'
  },
  {
    path: 'public/calculations/:id',
    redirectTo: 'calculations/:id'
  },
  {
    path: '**',
    redirectTo: ''
  }
];

